/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import styled from 'styled-components';
import { styled as mstyled } from '@mui/material/styles';

const CustomSelect = mstyled(TextField)(props => ({
  borderRadius: props.borderradius,
  backgroundColor: props.bgcolor,
  border: props.requiredError ? '2px solid #F26B29' : 'none',
  '& .MuiInputLabel-root': {
    fontSize: props.placeholderfontsize,
    color: props.requiredError ? '#F26B29' : props.placeholdercolor,
    opacity: 1,
    fontFamily: 'Gilroy, Roboto',
    top: props.isClientForm ? '2px' : '-5px',
  },
  '& .MuiOutlinedInput-input': {
    border: props.border,
    borderRadius: props.borderradius,
    outline: props.placeholdercolor,
    '&:focus': {
      borderRadius: props.borderradius,
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'transparent',
  },
  '& .MuiOutlinedInput-root': {
    borderRadius: props.borderradius,
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #ded9d9',
    },
  },
  '& .MuiOutlinedInput-root:hover': {
    border: props.requiredError ? '2px solid #F26B29' : 'none',
  },
  '& .MuiInputLabel-shrink': {
    display: 'none',
  },
  '& .MuiSelect-select': {
    padding: props.padding,
    border: '1px solid #ded9d9',
  },
  '& input': {
    '&::placeholder': {
      fontSize: props.placeholderfontsize,
      color: props.requiredError ? '#F26B29' : props.placeholdercolor,
      opacity: 1,
      fontFamily: 'Gilroy, Roboto',
    },
  },
}));

const RequiredNotice = styled.div`
  font-size: 14px;
  color: ${props => props.requiredcolor || '#fff'};
  margin-bottom: 5px;
  display: flex;
`;

function SelectField({
  grid,
  borderradius,
  border,
  padding,
  bgcolor,
  placeholdercolor,
  required,
  placeholderfontsize,
  fontsize,
  name,
  placeholder,
  type,
  endAdornment,
  requiredcolor,
  handleChange,
  label,
  labelcolor,
  errorMessage,
  data,
  isFetched,
  defaultValue,
  isAddresses,
  requiredError,
  isClientForm,
}) {
  const items = isFetched && data && data.map(item => (
    <MenuItem color={placeholdercolor} key={item.id} value={item.id}>{isAddresses ? item.address : item.name}</MenuItem>));
  return (
    <Grid item xs={grid}>
      {required && (
        <RequiredNotice requiredcolor={requiredcolor}>
          *
          {' '}
          <Typography fontSize="12px" marginLeft="2px">{label}</Typography>
        </RequiredNotice>
      )}
      {!required
        && (
        <Typography color={labelcolor} fontSize="12px">
          {label}
        </Typography>
        )}

      <CustomSelect
        labelId="demo-simple-select-helper-label"
        onChange={e => handleChange(e.target.value)}
        name={name}
        value={defaultValue}
        fullWidth
        size="large"
        placeholdercolor={placeholdercolor}
        label={placeholder}
        placeholderfontsize={placeholderfontsize || 12}
        placeholder={placeholder}
        borderradius={borderradius}
        border={border}
        bgcolor={bgcolor}
        padding={padding}
        id={name}
        type={type}
        endAdornment={endAdornment}
        fontSize={fontsize}
        requiredError={requiredError}
        select
        isClientForm={isClientForm}
      >
        {items}
      </CustomSelect>
      {errorMessage
       && (
       <Typography color="#fbb140" fontSize="13px" fontWeight={600}>
         {errorMessage}
       </Typography>
       )}
    </Grid>
  );
}

SelectField.propTypes = {
  grid: PropTypes.number,
  padding: PropTypes.string,
  borderradius: PropTypes.number,
  bgcolor: PropTypes.string,
  border: PropTypes.string,
  required: PropTypes.bool,
  placeholdercolor: PropTypes.string,
  placeholderfontsize: PropTypes.number,
  fontsize: PropTypes.number,
  name: PropTypes.string,
  defaultValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  placeholder: PropTypes.string,
  type: PropTypes.string,
  endAdornment: PropTypes.node,
  requiredcolor: PropTypes.string,
  handleChange: PropTypes.func,
  label: PropTypes.string,
  labelcolor: PropTypes.string,
  errorMessage: PropTypes.string,
  isFetched: PropTypes.bool,
  isAddresses: PropTypes.bool,
  requiredError: PropTypes.bool,
  isClientForm: PropTypes.bool,
};

SelectField.defaultProps = {
  grid: 12,
  padding: '',
  borderradius: 0,
  bgcolor: 'transparent',
  border: '',
  required: false,
  placeholdercolor: '#ccc',
  placeholderfontsize: 14,
  fontsize: 14,
  name: '',
  defaultValue: '',
  placeholder: '',
  type: 'text',
  endAdornment: null,
  requiredcolor: '#fff',
  label: '',
  labelcolor: '#a9a9a9',
  errorMessage: '',
  isFetched: false,
  isAddresses: false,
  requiredError: false,
  isClientForm: false,
};
export default SelectField;
